var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/eventSourceManager.ts
var EventSourceManager = class {
  static {
    __name(this, "EventSourceManager");
  }
  _name;
  _eventSource = null;
  constructor(name) {
    this._name = name;
  }
  init(url) {
    if (!this._eventSource) {
      this._eventSource = new EventSource(url);
      window[this._name] = this._eventSource;
    }
  }
  close() {
    if (window[this._name]) {
      window[this._name].close();
      window[this._name] = void 0;
    }
  }
  subscribe(handler) {
    this._eventSource?.addEventListener("message", handler);
  }
  unsubscribe(handler) {
    this._eventSource?.removeEventListener("message", handler);
  }
  addErrorHandler(handler) {
    this._eventSource?.addEventListener("error", handler);
  }
  removeErrorHandler(handler) {
    this._eventSource?.removeEventListener("error", handler);
  }
  get isInitialized() {
    return Boolean(window[this._name]);
  }
};

// src/autoPricingService.ts
var AutoPricingService = class {
  static {
    __name(this, "AutoPricingService");
  }
  _eventSourceManager;
  _baseURL;
  constructor(eventSourceManager, baseURL) {
    this._eventSourceManager = eventSourceManager;
    this._baseURL = baseURL;
  }
  init(carleadHash) {
    this._eventSourceManager.init(
      `${this._baseURL}/self-evaluation-client-notifications/autopricing/${carleadHash}`
    );
  }
  get isInitialized() {
    return this._eventSourceManager.isInitialized;
  }
  #createMessageHandler(onMessage, onError, options) {
    const handler = /* @__PURE__ */ __name((event) => {
      if (options.single) {
        this._eventSourceManager.unsubscribe(handler);
      }
      try {
        const eventData = JSON.parse(event.data);
        onMessage({ status: eventData.data.status });
      } catch (err) {
        onError(err);
      }
    }, "handler");
    return handler;
  }
  listenOnce() {
    return new Promise((resolve, reject) => {
      this.listen(resolve, reject, { single: true });
    });
  }
  listen(onMessage, onError, options = {}) {
    const handler = this.#createMessageHandler(onMessage, onError, options);
    const errorHandler = /* @__PURE__ */ __name((err) => {
      this._eventSourceManager.unsubscribe(handler);
      this._eventSourceManager.removeErrorHandler(errorHandler);
      onError(err);
    }, "errorHandler");
    this._eventSourceManager.addErrorHandler(errorHandler);
    this._eventSourceManager.subscribe(handler);
    return () => {
      this._eventSourceManager.unsubscribe(handler);
      this._eventSourceManager.removeErrorHandler(errorHandler);
    };
  }
  closeConnection() {
    this._eventSourceManager.close();
  }
};

// src/statuses.ts
var Statuses = {
  IN_PROGRESS: "in-progress",
  TIMEOUT: "timeout",
  FAILURE: "failure",
  SKIPPED: "skipped",
  SUCCESS: "success"
};
export {
  AutoPricingService,
  Statuses as AutoPricingStatuses,
  EventSourceManager
};
//# sourceMappingURL=index.mjs.map